import React from 'react';
import './theme/variables.css';
import './theme/global.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components//Layout/Layout';
import Home from './pages/Home/Home';
import Error404 from './pages/404/404';
import PrivacyPolicy from './pages/Privacy/Privacy';
import TermsOfService from './pages/Terms/Terms';
import TermsOfUse from './pages/EULA/EULA';
import Support from './pages/Support/Support';
import CookieConsent from './components/CookieConsent/CookieConsent';


function App() {
  return (
    <>
      <CookieConsent />
      <Routes>

        {/* All routes that share Navbar/Footer go here */}
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<TermsOfService />} />
          <Route path="eula" element={<TermsOfUse />} />
          <Route path="support" element={<Support />} />

          {/* Catch-all route for 404 */}
          <Route path="*" element={<Error404 />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
